<ng-content select="[changeDeviceLink]"></ng-content>
<div class="row m-t-xl">
  <div class="col-3 col-md-2 col-lg-2">
    <div class="row">
      <div class="col-sm-12 text-center p-l-xs" *ngIf="mainImageUrl; else noImageAvailable">
        <img class="img-fluid inline-block mobile-view-height" [src]="mainImageUrl || ''" alt="{{deviceDetails?.familyName}}" id="device-image">
      </div>
      <ng-template #noImageAvailable>
        <div class="col-sm-12 text-center">
          <img id="no-image" class="img-fluid inline-block" [src]="dummyImage" alt="FPO Image" />
        </div>
      </ng-template>
    </div>
  </div>

  <div class="col-9 col-md-10 p-0 m-t-xl xs-m-t-sm sm-m-t-md mobile-view-width">
    <div class="row">
      <div class="col-12">
        <p class="text-small m-b-sm xs-m-b-xs sm-m-b-xs">{{ deviceName }}</p>
        <span *ngIf="selectedDevice?.memory && selectedDevice?.color">
          {{ selectedDevice?.memory }},{{ selectedDevice?.color }}
        </span>
      </div>
    </div>
  </div>
</div>
